import audioPlayer from './audioPlayer.js';

let enterPage = {
  init: function() {
    const startPage = document.querySelector('.start-page');
    const enterBtns = startPage && startPage.querySelectorAll('.start-button-wrapper');
    if (!startPage || !enterBtns || !enterBtns.length) return;
    const startExperience = () => {
      // Add fade-out class
      startPage.classList.add('fade-out');
      // After animation, hide start page
      startPage.addEventListener('animationend', function handler() {
        startPage.style.display = 'none';
        startPage.removeEventListener('animationend', handler);
      });
      // Play first audio track
      if (audioPlayer && typeof audioPlayer.playIndex === 'function') {
        audioPlayer.playIndex(0);
      }
    };

    enterBtns.forEach(btn => {
      btn.addEventListener('click', startExperience);
    });
  },
}
export default enterPage;